var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-list"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.articleList),function(item){return _c('article-card',{key:item.articleId,staticClass:"mb-3",attrs:{"article":item,"size":"small"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }